import type { Address } from '@features/cart/types';

const COMMERCE_API_BASE = import.meta.env.VITE_COMMERCE_API_BASE_URL || '/api/commerce';

async function postJson<TResponse>(
  path: string,
  body: unknown,
  idToken?: string | null
): Promise<TResponse> {
  const response = await fetch(`${COMMERCE_API_BASE}${path}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(idToken ? { Authorization: `Bearer ${idToken}` } : {}),
    },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    const text = await response.text();
    throw new Error(text || `Commerce API failed with ${response.status}`);
  }

  return response.json() as Promise<TResponse>;
}

export interface ResolveShopCustomerResponse {
  shopId: string;
  customer: {
    id: string;
    email?: string | null;
    shop_id: string | null;
    name: string;
    mobile: string;
    user_type: string;
  } | null;
}

export function resolveShopCustomerViaBff(
  body: { shopId: string; phone: string; name?: string | null; email?: string | null },
  idToken?: string | null
): Promise<ResolveShopCustomerResponse> {
  return postJson('/identity/resolve-shop-customer', body, idToken);
}

export function cloneAddressToShopViaBff(
  body: {
    address: Address;
    targetUserId: string;
    targetShopId: string;
    contactEmail?: string | null;
    isDefault?: boolean;
  },
  idToken?: string | null
): Promise<{ address: Address | null }> {
  return postJson('/address/clone-to-shop', body, idToken);
}
